const initialState = {
  obj: {}
}

const userDataRed = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_DATA': {
      return {
        ...state,
        obj: action.obj
      }
    }
    default: {
      return state
    }
  }
}

export default userDataRed
